import React from "react"
import { useTranslation } from "react-i18next"

export const AttachDiscountMenuItemContent = () => {
    const { t } = useTranslation()

    return (
        <>
            <div className="flex items-center">
                <p className="leading-none">
                    <span className="text-text">{t("action:request.attach_discount")}</span>
                </p>
            </div>
        </>
    )
}
